export const FLEX_KEY = process.env.FLEX_KEY || ''
